export const blockIconsMapsLocalHospital = (
	<span className='material-symbols-outlined'>local_hospital</span>
);
